import type { GetAllMerchantInfoForFirm } from '@cloudFunctions/types/clientToFirmPayments/getAllMerchantInfoForFirm';
import type { CreatePaymentPage } from '@cloudFunctions/types/clientToFirmPayments/createPaymentPage';
import type { GetPaymentPagesAuthenticated } from '@cloudFunctions/types/clientToFirmPayments/getPaymentPagesAuthenticated';
import type { CreateFirmOnboardingForms } from '@cloudFunctions/types/clientToFirmPayments/createFirmOnboardingForms';
import type { CreateFirmOnboardingFormLink } from '@cloudFunctions/types/clientToFirmPayments/createFirmOnboardingFormLink';
import { invokeBackendRoute } from '@/backend/invoke';

export type {
  CreatePaymentPage,
  GetPaymentPagesAuthenticated,
  GetAllMerchantInfoForFirm,
  CreateFirmOnboardingForms,
  CreateFirmOnboardingFormLink,
};

// =============================================================================
// Create Payment Page
// =============================================================================

export const createPaymentPage = async (
  requestData: CreatePaymentPage.Props,
): Promise<CreatePaymentPage.Result> =>
  invokeBackendRoute<CreatePaymentPage.Result, CreatePaymentPage.Props>(
    'createPaymentPage',
    requestData,
  );

// =============================================================================
// Get Payment Pages (Authenticated)
// =============================================================================

export const getPaymentPagesAuthenticated = async (
  requestData: GetPaymentPagesAuthenticated.RequestData,
): Promise<GetPaymentPagesAuthenticated.Result> =>
  invokeBackendRoute<
    GetPaymentPagesAuthenticated.Result,
    GetPaymentPagesAuthenticated.RequestData
  >('getPaymentPagesAuthenticated', requestData);

// =============================================================================
// Get Firm Merchant Accounts
// =============================================================================

export const getAllMerchantInfoForFirm = async (
  requestData: GetAllMerchantInfoForFirm.RequestData,
): Promise<GetAllMerchantInfoForFirm.Result> =>
  invokeBackendRoute<
    GetAllMerchantInfoForFirm.Result,
    GetAllMerchantInfoForFirm.RequestData
  >('getAllMerchantInfoForFirm', requestData);

// =============================================================================
// Save Credit Card Payment Info
// =============================================================================

export const saveAchPaymentMethod = async (props: unknown) =>
  invokeBackendRoute<unknown, unknown>('saveAchPaymentMethod', props);

export const createFirmOnboardingForms = async (
  requestData: CreateFirmOnboardingForms.RequestData,
): Promise<CreateFirmOnboardingForms.Result> =>
  invokeBackendRoute<
    CreateFirmOnboardingForms.Result,
    CreateFirmOnboardingForms.RequestData
  >('createFirmOnboardingForms', requestData);

export const createFirmOnboardingFormLink = async (
  requestData: CreateFirmOnboardingFormLink.RequestData,
): Promise<CreateFirmOnboardingFormLink.Result> =>
  invokeBackendRoute<
    CreateFirmOnboardingFormLink.Result,
    CreateFirmOnboardingFormLink.RequestData
  >('createFirmOnboardingFormLink', requestData);
